<template>
  <v-card outlined class="white box-height-100 py-6 px-2" :elevation="5">
    <div class="title-time-serie">{{ title }}</div>
    <v-chart
      :option="polar"
      autoresize
      :style="{ height: '100%', width: '100%', marginTop: '-20px' }"
    />
  </v-card>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, LinesChart } from 'echarts/charts'
import {
  GridComponent,
  MarkPointComponent,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  LegendComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

import moment from 'moment'
import variables from '@/styles/variables.scss'

use([
  CanvasRenderer,
  LineChart,
  LinesChart,
  GridComponent,
  TitleComponent,
  ToolboxComponent,
  MarkPointComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  components: {
    VChart
  },
  props: {
    color: Array,
    timer: Number,
    type: String,
    title: String,
    xAxis: Array,
    yAxis: Object,
    data1: Object,
    data2: Object,
    data3: Object,
    height: String
  },
  watch: {
    timer: {
      // immediate: true,
      handler(val) {
        if (this.data1.data.length < 1) return

        this.data2.markPoint = {
          data: [
            {
              yAxis: this.data2.data[this.data2.data.length - 1][1],
              x: '90%',
              value: this.data2.data[this.data2.data.length - 1][1]
            }
          ],
          symbol: 'pin',
          symbolSize: 60,
          symbolRotate: 270,
          label: {
            position: 'inside',
            offset: [6, 6],
            fontSize: 16,
            formatter: params => {
              return `${params.value.toLocaleString()}`
            }
          }
        }

        this.data3.markPoint = {
          data: [
            {
              yAxis: this.data3.data[this.data3.data.length - 1][1],
              x: '90%',
              value: this.data3.data[this.data3.data.length - 1][1]
            }
          ],
          symbol: 'pin',
          symbolSize: 60,
          symbolRotate: 270,
          label: {
            position: 'inside',
            offset: [6, 6],
            fontSize: 16,
            formatter: params => {
              return `${params.value.toLocaleString()}`
            }
          }
        }

        this.chart()
      }
    }
  },
  data() {
    return {
      polar: {},
      tmpValue1: 0,
      tmpValue2: 0,
      tmpValue3: 0
    }
  },
  methods: {
    viewVoice() {
      return this.type === 'voice'
    },
    viewChat() {
      return this.type === 'chat'
    },
    viewAll() {
      return this.type === 'all'
    },
    chart() {
      const legends = []
      const series = []
      const color = []

      if (this.viewAll() || this.viewVoice()) {
        legends.push({
          name: this.data1.name,
          lineStyle: {
            type: 'dotted'
          }
        })

        series.push(this.data1)
        color.push(this.data1.lineStyle.color)

        legends.push({
          name: this.data2.name,
          lineStyle: {
            type: 'solid'
          }
        })
        series.push(this.data2)
        color.push(this.data2.lineStyle.color)
      }
      if (this.viewAll() || this.viewChat()) {
        legends.push({
          name: this.data3.name,
          lineStyle: {
            type: 'solid'
          }
        })
        series.push(this.data3)
        color.push(this.data3.lineStyle.color)
      }

      this.polar = {
        color,
        textStyle: {
          fontFamily: variables.fontFamily
        },
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            const date = params[0].data[0]

            if (this.viewAll()) {
              const voice = params[1].data[1]
              const chat = params[2].data[1]

              return `${moment(date).format(
                'HH:mm:ss'
              )} : ${voice} calls, ${chat} chats`
            } else if (this.viewVoice()) {
              const voice = params[1].data[1]

              return `${moment(date).format(
                'HH:mm:ss'
              )} : ${voice.toLocaleString()} calls`
            } else if (this.viewChat()) {
              const chat = params[0].data[1]

              return `${moment(date).format(
                'HH:mm:ss'
              )} : ${chat.toLocaleString()} chats`
            }
          }
        },
        legend: {
          // data: legends,
          left: 'center',
          bottom: '5px'
        },
        calculable: true,
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function(value) {
                return moment(value).format('HH:mm')
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: true
            }
          }
        ],
        series
      }
    }
  }
}
</script>
